require('./plugins/morrisjs/morris.min');

window.route = function(route, params) {
	let url = route in $Routes ? $Routes[route] : null;
	if (url) {
		if (params) {
			$.each(params, function(index, val) {
				url = url.replace('{'+index+'}', val);
			});
		}
		let base = $('base').attr('href');
		url = base + "/" + url;
	} else {
		console.error('Route "'+route+'" not found.');
	}
	return url;
};


window.getNextKey = function ($parent) {
	var newKey = 0;
	$parent.children().each(function (i, child) {
		newKey = Math.max( newKey, (parseInt($(child).data('key')) + 1) );
	});
	return newKey;
};


window.parseDateTime = function (str) {
	let time = new Date(0);
	var matches = str.match(/(?<d>\d+)\.(?<m>\d+)\.(?<y>\d+)(?<t>\s+[^\s]+)?/);
	if (matches && ('groups' in matches) && matches.groups) {
		if ('d' in matches.groups) {
			time.setDate(parseInt(matches.groups.d));
			time.setMonth(parseInt(matches.groups.m) - 1);
			time.setFullYear(parseInt(matches.groups.y));
		}
		if (('t' in matches.groups) && matches.groups.t) {
			let matches2 = matches.groups.t.match(/\s+(?<h>\d+):(?<m>\d+)(?<s>:\d+)?/);
			if (matches2 && ('groups' in matches2) && matches2.groups) {
				if ('h' in matches2.groups) {
					time.setHours(parseInt(matches2.groups.h));
					time.setMinutes(parseInt(matches2.groups.m));
					if (('s' in matches2.groups) && matches2.groups.s) {
						time.setSeconds(parseInt(matches2.groups.s.substr(1)));
					}
				}
			}
		}
	}
	return time;
};

window.formatDate = function (date) {
	return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
};

window.formatDateTime = function (date, appendSeconds) {
	return date.getDate()  + "." + (date.getMonth()+1) + "." + date.getFullYear() + " "
		+ date.getHours() + ":" + Morris.pad2(date.getMinutes()) 
		+ (appendSeconds ? (":" + Morris.pad2(date.getSeconds())) : "");
};
